import React, { useEffect, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

import {
  PostTypeEnum,
} from '@professocial/professocialTypes/types/commonTypes'
import ImageComponent from '@professocial/professocialFormComponents/FormComponents/ImageComponent'
import PlayCircleFilledRounded from '@mui/icons-material/PlayCircleFilledRounded'
import Heart from '../../../shared/icons/Instagram/Heart'
import CommentIcon from '../../../shared/icons/Comment'
import EyeIcon from '@mui/icons-material/RemoveRedEye'
import InstagramLightBox from './InstagramGallery/InstagramLiteBox'
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded'

import { IInstagramPostProps } from './InstagramPostTemplate'
import { InstagramPost } from '@3m5/sm_publish-frontend-api'
import { generateVideoThumbnailViaUrl } from '@rajesh896/video-thumbnails-generator'

const InstagramOverview: React.FC<IInstagramPostProps> = (props: IInstagramPostProps) => {
  const [post, setPost] = useState<InstagramPost>(props.post as InstagramPost)
  const [videoThumbnail, setVideoThumbnail] = useState<string>()

  const useStyles = makeStyles((theme: Theme) => ({
    imageContainer: {
      position: 'relative',
      margin: '2.5px',
      cursor: 'pointer',
      height: props.width ? props.width : '193px',
      width: props.width ? props.width : '193px',
      '&:hover > $overlay': {
        opacity: '0.64',
      },
      '&:hover > $iconBlock': {
        opacity: 1,
      },
    },
    image: {
      position: 'relative',
      objectFit: 'cover',
      height: props.width ? props.width : '193px',
      width: props.width ? props.width : '193px',
      zIndex: 0,
    },
    overlay: {
      position: 'absolute',
      display: 'block',
      height: props.width ? props.width : '193px',
      width: props.width ? props.width : '193px',
      top: 0,
      left: 0,
      background: '#000000 0% 0% no-repeat padding-box',
      opacity: 0,
      zIndex: 1,
    },
    iconBlock: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: props.width ? props.width : '193px',
      width: props.width ? props.width : '193px',
      opacity: 0,
      top: 0,
      left: 0,
      zIndex: 2,
    },
    typeIcon: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      height: props.width ? props.width : '193px',
      width: props.width ? props.width : '193px',
      top: 0,
      left: 0,
      zIndex: 1,
      '& svg': {
        margin: '8px',
      },
    },
    counter: {
      padding: theme.spacing(0.5),
      '& span': {
        color: '#fff',
        padding: '5px',
        verticalAlign: 'middle',
      },
    },
    icon: {
      verticalAlign: 'top',
    },
    animated: {
      animation: '$scale .5s ease-in-out  alternate',
    },
    '@keyframes scale': {
      '0%': {
        opacity: 0,
        transform: 'scale(1.0)',
      },
      '50%': {
        opacity: 1,
        transform: 'scale(1.2)',
      },
      '100%': {
        opacity: 1,
        transform: 'scale(1.0)',
      },
    },
    backgroundLayer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgb(0,0,0,0.6)',
    },
    preloader: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    },
  }))

  const classes = useStyles()
  const postStatistics = post && post.postStatistics
  const postType = post.content[0]?.video ? PostTypeEnum.VIDEO : PostTypeEnum.PHOTO
  const src = postType === PostTypeEnum.VIDEO && post.content[0]?.video ? post.content[0]?.video?.previewImageUrl : (post.content[0]?.image ? post.content[0]?.image.url : '')

  useEffect(() => {
    setPost(props.post as InstagramPost)
  }, [props.post])

  useEffect(() => {
    if (post?.content[0]?.video?.url) {
      generateVideoThumbnailViaUrl(post.content[0]?.video.url, 2).then((value) => {
        setVideoThumbnail(value)
      })
    }
  }, [])

  return (
    <>
      <InstagramLightBox post={post} networkPageId={props.networkPageId} videoThumbnail={videoThumbnail} networkType={props.networkType}>
        <div className={`${classes.imageContainer} `}>
          <ImageComponent src={src || videoThumbnail} fallback='/src/shared/assets/images/icon-img-placeholder.svg' className={classes.image} />

          {postType === PostTypeEnum.VIDEO && (
            <div className={classes.typeIcon}>
              <PlayCircleFilledRounded style={{ color: '#fff', filter: 'drop-shadow( 0px 0px 3px rgba(0, 0, 0, .5))' }} />
            </div>)}

          {postType === PostTypeEnum.PHOTO && post.content.length > 1 && (
            <div className={classes.typeIcon}>
              <GridViewRoundedIcon style={{ color: '#fff', filter: 'drop-shadow( 1px 1px 4px rgba(0, 0, 0, .8))' }} />
            </div>)}

          <div className={classes.overlay} />
          <div className={classes.iconBlock}>
            <div className={classes.counter}><Heart className={classes.icon} color='#fff' width='23px' /><span>{postStatistics && postStatistics.likeCount}</span></div>
            <div className={classes.counter}><CommentIcon className={classes.icon} color='#fff' width='23px' /><span>{postStatistics && postStatistics.commentCount}</span></div>
            <div className={classes.counter}><EyeIcon className={classes.icon} sx={{ color: '#fff' }} width='23px' /><span>{postStatistics && postStatistics.reach}</span></div>
          </div>
        </div>
      </InstagramLightBox>
    </>
  )
}

export default InstagramOverview
